// ** React Imports
import { matchPath, useLocation, useParams } from "react-router-dom";

// ** Redux
import { getUserProfileMain } from "store/modules/user-profile/actions/get-user-profile-main.action";
import { useDispatch, useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import NavItemLink from "components/base/NavItemLink";
import Item from "components/layout/Nav/Item";

// #####################################################

export const UserNavSectionProfileItem = () => {
	const { login } = useParams();

	const location = useLocation();
	const dispatch = useDispatch();

	const isAuth = useSelector((state) => state.globalCommon.isAuth);

	const { t } = useTranslation();

	// #####################################################

	return (
		<NavItemLink
			container={Item}
			to={`/users/${login.toLowerCase()}`}
			key={`profile`}
			exact={true}
			onClick={() => {
				const match = matchPath(location.pathname, {
					path: `/users/:login`,
					exact: true,
				});
				if (match) {
					dispatch(
						getUserProfileMain({
							login,
							isAuth,
							throwError: "true",
						})
					);
				}
			}}
		>
			<Item.Content
				noPad
				flex
				style={{
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				{t(`userProfile:userProfile`)}
			</Item.Content>
		</NavItemLink>
	);
};

// #####################################################
